import { Link } from "react-router-dom";
import { motion as Motion } from "framer-motion";
import i18n from "@/i18n";
import cls from "./NotyVlogComingSoon.module.scss";

const floatSlow = {
  animate: {
    y: [0, -18, 0],
    rotate: [0, 3, 0, -3, 0],
    transition: { duration: 7, repeat: Infinity, ease: "easeInOut" },
  },
};

const pulse = {
  animate: {
    scale: [1, 1.08, 1],
    opacity: [0.35, 0.75, 0.35],
    transition: { duration: 3.8, repeat: Infinity, ease: "easeInOut" },
  },
};

export default function NotyVlogComingSoon() {
  const t = (key, options) => i18n.t(key, options);

  return (
    <main className={cls.page}>
      <div className={cls.bg} aria-hidden="true">
        <span className={cls.grid} />

        <Motion.span
          className={cls.orbOne}
          variants={pulse}
          animate="animate"
        />
        <Motion.span
          className={cls.orbTwo}
          variants={pulse}
          animate="animate"
        />
        <Motion.span
          className={cls.orbThree}
          variants={pulse}
          animate="animate"
        />

        <span className={cls.lineOne} />
        <span className={cls.lineTwo} />
        <span className={cls.lineThree} />

        <span className={cls.starOne} />
        <span className={cls.starTwo} />
        <span className={cls.starThree} />
      </div>

      <section className={cls.shell}>
        <Motion.div
          className={cls.card}
          initial={{ opacity: 0, y: 28, scale: 0.96 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          transition={{ duration: 0.7, ease: "easeOut" }}
        >
          <Motion.div
            className={cls.iconWrap}
            variants={floatSlow}
            animate="animate"
          >
            <div className={cls.iconGlow} />
            <div className={cls.icon}>📡</div>
          </Motion.div>

          <div className={cls.status}>
            <span />
            {t("notyVlog.status", {
              defaultValue: "Network Loading",
            })}
          </div>

          <p className={cls.kicker}>
            {t("notyVlog.sneak", {
              defaultValue: "Public Media Layer of Noty Universe",
            })}
          </p>

          <h1>
            {t("notyVlog.title", {
              defaultValue: "Noty Network is Coming Soon",
            })}
          </h1>

          <p className={cls.copy}>
            {t("notyVlog.copy", {
              defaultValue:
                "A public window into the clubs, stories, videos, articles, discussions, and ideas living inside Noty Universe. Browse the highlights, discover your topic, and log in to unlock the full experience.",
            })}
          </p>

          <div className={cls.topicGrid}>
            <div>
              <strong>01</strong>
              <span>Love & Connection</span>
            </div>
            <div>
              <strong>02</strong>
              <span>Science & Future Thinking</span>
            </div>
            <div>
              <strong>03</strong>
              <span>Geopolitics & Economics</span>
            </div>
            <div>
              <strong>04</strong>
              <span>History, Philosophy & Religion</span>
            </div>
          </div>

          <div className={cls.features}>
            <div>
              <strong>Stories</strong>
              <span>Public club stories and featured moments</span>
            </div>
            <div>
              <strong>Videos</strong>
              <span>Short previews, talks, and creator clips</span>
            </div>
            <div>
              <strong>Articles</strong>
              <span>Ideas, opinions, guides, and deep thoughts</span>
            </div>
          </div>

          <div className={cls.progressBox}>
            <div className={cls.progressTop}>
              <span>Noty Network Build</span>
              <b>78%</b>
            </div>

            <div className={cls.progressTrack}>
              <Motion.span
                initial={{ width: "18%" }}
                animate={{ width: ["18%", "78%", "58%", "78%"] }}
                transition={{
                  duration: 5,
                  repeat: Infinity,
                  ease: "easeInOut",
                }}
              />
            </div>
          </div>

          <div className={cls.ctaRow}>
            <Link to="/" className={cls.btnPrimary}>
              {t("notyVlog.backHome", {
                defaultValue: "Back to Home",
              })}
            </Link>

            <Link to="/explore-universe" className={cls.btnGhost}>
              {t("notyVlog.explore", {
                defaultValue: "Explore Universe",
              })}
            </Link>
          </div>
        </Motion.div>
      </section>
    </main>
  );
}
